import { FC } from 'react'

import { Container } from 'components/container'
import { Copyright, StyledFooter } from './styled'
import { useAppContext } from 'context/app-context'
import { Share } from '../share'

type Props = {}

export const Footer: FC<Props> = () => {
  const { strings } = useAppContext()

  return (
    <StyledFooter>
      <Container>
        <div>
          <h3>{strings.footer.followUs}</h3>
          <Share isVisible />
        </div>
        <div>
          <h3>{strings.footer.aboutTitle}</h3>
          {strings.footer.about.map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </div>
        <Copyright>{strings.footer.copyright}</Copyright>
      </Container>
    </StyledFooter>
  )
}
